import { toast } from "@ui-kit/Toast";
import { useEffect } from "react";
import type { ToolsError } from "../../model/types";
import { tui } from "../locale";
import { useWorkspaceToolsStore } from "../store/useWorkspaceToolsStore";
import { isUpdateFailure, useUnseenError } from "./useUnseenError";

export const UPDATE_FAILED_TOAST = "workspace-tools-update-failed";

const reasonOf = ({ code }: ToolsError): string => (code ? tui(`update-failed.${code}`) : tui("update-failed.other"));

/** Every background fetch fails again, offline or refused: the user hears of it once a session in each workspace. */
export const useUpdateFailureToast = () => {
	const error = useUnseenError();
	const failure = error && isUpdateFailure(error) ? error : null;
	const failedSeq = failure?.seq ?? null;
	const reason = failure ? reasonOf(failure) : null;

	useEffect(() => {
		if (failedSeq === null) return;
		const store = useWorkspaceToolsStore.getState();
		if (store.updateFailureToldIn.has(store.workspace)) return;
		store.markUpdateFailureTold();
		toast(tui("update-failed"), { id: UPDATE_FAILED_TOAST, description: reason, size: "lg", status: "warning" });
	}, [failedSeq, reason]);
};
